module.exports = __webpack_public_path__ + "static/media/MicrosoftTeams-image (4).0a4d2c6f.png";